/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonsaddinplace4Inputs */

const en_listingbuttonsaddinplace4 = /** @type {(inputs: Listingbuttonsaddinplace4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`add it to the place`)
};

const de_listingbuttonsaddinplace4 = /** @type {(inputs: Listingbuttonsaddinplace4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`im Ort ergänzen`)
};

/**
* | output |
* | --- |
* | "add it to the place" |
*
* @param {Listingbuttonsaddinplace4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsaddinplace4 = /** @type {((inputs?: Listingbuttonsaddinplace4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsaddinplace4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsaddinplace4(inputs)
	return de_listingbuttonsaddinplace4(inputs)
});
export { listingbuttonsaddinplace4 as "listingButtonsAddInPlace" }